<template>

  <div class="dmb-slide" ref="slide" :class="resolvedClasses" :style="resolvedStyles">

    <dmb-element-background
        :freeze="freeze"
        :asset-id="slide.backgroundAssetId"
        :color="backgroundColor"
        z-index="auto"
    ></dmb-element-background>

    <slot></slot>
  </div>

</template>

<script>

import {Options, Vue} from 'vue-class-component';
import Orientation from '../enum/Orientation';
import ElementBackground from './ui/ElementBackground.vue';


export default Options({
  name: 'dmb-slide',
  props: {
    slide: Object,
    orientation: String,
    freeze: Boolean
  },
  components: {

    [ElementBackground.name]: ElementBackground
  }
})(
    class Slide extends Vue {
      slideResizeObserver = null;
      fontSize = 10;
      scaleFactor = 1;

      resizeThrottleId = null;
      lastResizeTime = 0;

      resolvedClassesCache = null;
      lastOrientation = null;

      get backgroundColor() {
        return this.slide.backgroundColor || 'FFFFFF';
      }

      get resolvedClasses() {
        if (this.lastOrientation === this.orientation && this.resolvedClassesCache) {
          return this.resolvedClassesCache;
        }

        let classes = [];
        switch (this.orientation) {
          case Orientation.PORTRAIT:
            classes.push('portrait');
            break;

          case Orientation.LANDSCAPE:
            classes.push('landscape');
            break;
        }

        this.resolvedClassesCache = classes;
        this.lastOrientation = this.orientation;
        return classes;
      }

      get resolvedStyles() {
        return {
          'font-size': `${this.fontSize}px`,
          '--dmb-slide-scale-factor': this.scaleFactor
        };
      }

      mounted() {
        this.observeSlideResize();
      }

      unmounted() {
        this.cleanup();
      }

      cleanup() {
        if (this.slideResizeObserver) {
          this.slideResizeObserver.disconnect();
          this.slideResizeObserver = null;
        }

        if(this.resizeThrottleId) {
          cancelAnimationFrame(this.resizeThrottleId);
          this.resizeThrottleId = null;
        }
      }

      observeSlideResize() {
        if(!this.$refs.slide) {
          return;
        }

        this.slideResizeObserver = new ResizeObserver((entries) => {
          const now = performance.now();

          if (now - this.lastResizeTime < 16.67) {
            if (this.resizeThrottleId) {
              cancelAnimationFrame(this.resizeThrottleId);
            }

            this.resizeThrottleId = requestAnimationFrame(() => {
              this.handleResize(entries[0]);
              this.lastResizeTime = now;
            });
            return;
          }

          this.handleResize(entries[0]);
          this.lastResizeTime = now;
        });

        this.slideResizeObserver.observe(this.$refs.slide);
      }

      handleResize({ contentRect }) {
        const { width, height } = contentRect;
        const vmin = Math.min(width, height);

        const newFontSize = Math.floor(((width << 2) + (height << 2) + (vmin << 1)) / 100);
        const newScaleFactor = vmin / 720.0;

        if (this.fontSize !== newFontSize || Math.abs(this.scaleFactor - newScaleFactor) > 0.001) {
          this.fontSize = newFontSize;
          this.scaleFactor = newScaleFactor;
        }
      }
    }
);

</script>
<style src="../../scss/component/Slide.scss" lang="scss"></style>